import React, { forwardRef } from "react";
import { View } from "react-native";

import { Theme } from "../../../theme/restyle/theme";
import { Box } from "../Box/Box";

type BoxProps = React.ComponentProps<typeof Box>;

export type DividerProps = Omit<
  BoxProps,
  "backgroundColor" | "height" | "width"
> & {
  color?: keyof Theme["colors"];
  orientation?: "horizontal" | "vertical";
  thickness?: number;
};

export const Divider = forwardRef<View, DividerProps>(function Divider(
  {
    color = "surface-dividers",
    orientation = "horizontal",
    thickness = 1,
    ...props
  },
  ref
) {
  const isVertical = orientation === "vertical";

  return (
    <Box
      ref={ref}
      backgroundColor={color}
      height={isVertical ? "100%" : thickness}
      width={isVertical ? thickness : "100%"}
      {...props}
    />
  );
});
